<div class="headerContainer">
    <div class="container">
        <div class="logoContent">
            <div class="logo" *ngIf="!orgImage?.show">
                <figure>
                    <img src="https://assets.lntedutech.com/application_images/new-edutech-logo.webp" alt="" />
                </figure>
            </div>
            <h1>LearnKonnect</h1>
            <div class="orgLogo" *ngIf="orgImage?.show">
              <figure>
                <img [src]="orgImage?.img" alt="Organisation Logo"/>
              </figure>
            </div>
        </div>
        <div class="profileAvatar">
            <div class="adminDetails">
              <h1>Admin</h1>
              <span>{{userDetails?.firstname}} {{userDetails?.lastname}}</span>
            </div>
            <div class="loginImage" [matMenuTriggerFor]="menu">
                <span><em class="icon-User"></em></span>
                <mat-menu class="popup" #menu="matMenu" xPosition="before">
                    <div class="showAvatar">
                        <div class="profileMenu">
                            <div class="profile">
                                <div class="profIcon">
                                    <span><em class="icon-User"></em></span>
                                </div>
                                <div class="profDesc">
                                    <strong>{{userDetails?.firstname}}</strong>
                                    <span>{{email}}</span>
                                </div>
                            </div>
                            <div class="changepassword">
                                <span class="icon-changePassword"></span>
                                <a (click)="openDetail(changePswd)">Change Password</a>
                            </div>
                            <div class="signout">
                                <span class="icon-Logout"></span>
                                <a class="signOut" (click)="logout()">Sign out</a>
                            </div>
                        </div>
                    </div>
                </mat-menu>
            </div>
        </div>
    </div>
</div>

<ng-template #changePswd>
  <div class="passwordSection">
    <em class="icon-Close" (click)="closeDialog()"></em>
    <h2 class="heading">Change <span>Password!</span></h2>
    <form [formGroup]="accountSettingsForm" autocomplete="off">
      <div class="formFields">
        <div class="inputBox">
          <label>Current Password</label>
          <mat-form-field appearance="outline">
            <input matInput placeholder="Enter current password" onpaste="return false" autocomplete="off" [type]="currpasshide ? 'password' : 'text'" formControlName="currentPassword">
            <div mat-icon-button matSuffix (click)="currpasshide = !currpasshide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="currpasshide">
              <em class="{{currpasshide ? 'icon-Hide' : 'icon-View'}}"></em>
            </div>
          </mat-form-field>
          <ng-container *ngIf="currentPassword.invalid && currentPassword.touched">
            <mat-error *ngIf="currentPassword.errors?.required">{{'Password is required'}}</mat-error>
            <mat-error *ngIf="currentPassword.errors?.minlength">{{'Minimum 8 characters required'}}</mat-error>
            <mat-error *ngIf="currentPassword.errors?.maxlength">{{'Maximum 50 characters only allowed'}}</mat-error>
            <mat-error *ngIf="currentPassword.errors?.password">{{'Minimum of 1 uppercase, 1 lowercase, 1 numeric, 1 special character'}}</mat-error>
          </ng-container>
        </div>
        <div class="inputBox">
          <label>New Password</label>
          <mat-form-field appearance="outline">
            <input placeholder="Enter new password" onCopy="return false" onDrag="return false" onDrop="return false" onPaste="return false" autocomplete="off" matInput [type]="newpasshide ? 'password' : 'text'" formControlName="password">
            <div mat-icon-button matSuffix (click)="newpasshide = !newpasshide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="newpasshide">
              <em class="{{newpasshide ? 'icon-Hide' : 'icon-View'}}"></em>
            </div>
          </mat-form-field>
          <ng-container *ngIf="password.invalid && password.touched">
            <mat-error *ngIf="password.errors?.required">{{'Password is required'}}</mat-error>
            <mat-error *ngIf="password.errors?.minlength">{{'Minimum 8 characters required'}}</mat-error>
            <mat-error *ngIf="password.errors?.maxlength">{{'Maximum 50 characters only allowed'}}</mat-error>
            <mat-error *ngIf="password.errors?.password">{{'Minimum of 1 uppercase, 1 lowercase, 1 numeric, 1 special character.'}}</mat-error>
          </ng-container>
          <ng-container *ngIf="password?.touched">
            <mat-error *ngIf="accountSettingsForm.value.password == accountSettingsForm.value.currentPassword">{{'New password should be different from current password'}}</mat-error>
          </ng-container>
        </div>
        <div class="inputBox">
          <label>Confirm Password</label>
          <mat-form-field appearance="outline">
            <input onpaste="return false" placeholder="Enter confirm password" autocomplete="off" matInput [type]="conpasshide ? 'password' : 'text'" formControlName="confirmPassword">
            <div mat-icon-button matSuffix (click)="conpasshide = !conpasshide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="conpasshide">
              <em class="{{conpasshide ? 'icon-Hide' : 'icon-View'}}"></em>
            </div>
          </mat-form-field>
          <ng-container *ngIf="confirmPassword.invalid && confirmPassword.touched || (accountSettingsForm.errors?.notMatch && (accountSettingsForm.touched || accountSettingsForm.dirty))">
            <mat-error *ngIf="confirmPassword.invalid && confirmPassword.touched && confirmPassword.errors?.required">{{'Confirm Password is required'}}</mat-error>
            <mat-error *ngIf="!confirmPassword.errors?.required && accountSettingsForm.errors?.notMatch">{{'Confirm Password should match the new Password'}}</mat-error>
          </ng-container>
        </div>
        <div class="resetButton">
          <button type="submit" (click)="changePassword()" [disabled]="!accountSettingsForm.valid" [ngClass]="accountSettingsForm.valid ? 'save' : 'disable'">Submit</button>
        </div>
      </div>
    </form>
  </div>
</ng-template>
